import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'logic/moment';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import Success from 'components/shared/Success';
import { userData as userDataSelector } from 'selectors/user';
import BookingsList from '../components/BookingsList';
import { fetchBookingsListRequest, fetchBookingsListSuccess } from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

const BookingsListContainer = () => {
  const [form, setForm] = React.useState({
    status: '__none__',
    checkInFrom: moment().subtract(30, 'days').toISOString(),
    checkInTo: null,
    order: 'check_in ASC',
  });
  const dispatch = useDispatch();
  const error = useSelector(selectors.error);
  const isLoading = useSelector(selectors.isLoading);
  const list = useSelector(selectors.list);
  const nextPage = useSelector(selectors.nextPage);
  const success = useSelector(selectors.success);
  const currentUser = useSelector(userDataSelector);

  const fetchFirst = (values = form) => {
    dispatch(fetchBookingsListSuccess({ nextPage: null, reset: true }));

    const filters = {
      order: values.order,
    };

    if (values.status && values.status !== '__none__') {
      filters[values.status.toLowerCase()] = 1;
    }

    if (values.checkInFrom) {
      filters.checkInFrom = values.checkInFrom;
    }

    if (values.checkInTo) {
      filters.checkInTo = values.checkInTo;
    }

    dispatch(fetchBookingsListRequest({ limit: 10, offset: 0, ...filters }));
  };

  const resetList = () => {
    dispatch(fetchBookingsListSuccess({ nextPage: null, reset: true }));
  };

  const fetchMore = () => {
    dispatch(fetchBookingsListRequest({ nextPage }));
  };

  React.useEffect(() => {
    if (!isLoading) {
      fetchFirst();
    }

    return () => {
      resetList();
    };
  }, []);

  const onSubmit = (values) => {
    setForm({
      ...form,
      ...values,
    });

    return fetchFirst({
      ...form,
      ...values,
    });
  };

  return (
    <Main title={<FormattedMessage id="My Bookings" defaultMessage="My Bookings" />}>
      <InfiniteScroll initialLoad loadMore={fetchMore} hasMore={!!nextPage} threshold={10}>
        <BookingsList
          filters={form}
          list={list}
          onSubmit={onSubmit}
          isLoading={isLoading}
          currentUser={currentUser}
        />
      </InfiniteScroll>
      <Success success={success} />
      <Errors errors={error} />
    </Main>
  );
};

export default BookingsListContainer;
